import { NoSearchResult, Paragraph, YStack } from '@ninjacart/nc-nk-ui';
import { useTranslation } from 'react-i18next';

export const ProfileTabEmptyState = ({
  emptyStateContent,
}: {
  emptyStateContent?: string;
}) => {
  const { t } = useTranslation();

  return (
    <YStack
      justifyContent="center"
      alignItems="center"
      padding={16}
      marginVertical={20}
      borderRadius={50}
      marginTop={100}
    >
      <NoSearchResult height={100} width={'100%'} />
      <Paragraph
        paddingTop={5}
        fontSize={22}
        fontWeight={'600'}
        color={'$color'}
        marginTop={30}
        marginBottom={10}
        textAlign={'center'}
        lineHeight={30}
      >
        {emptyStateContent}
      </Paragraph>
    </YStack>
  );
};
